import { StatusBadge } from '@/components/common/StatusBadge';
import { formatCount } from '@/utils/number';
import { APPLIED_DAYS_TONE, DAY_UNIT } from '../constants/leaveApplication.constants';

interface AppliedDaysBadgeProps {
  appliedDays: number;
}

export function AppliedDaysBadge({ appliedDays }: AppliedDaysBadgeProps) {
  return <StatusBadge tone={APPLIED_DAYS_TONE}>{formatCount(appliedDays, DAY_UNIT)}</StatusBadge>;
}
